export const isMobile = window.innerWidth < 768;
// headerConfig.js
export const headerConfig = {
  "/": {
    type: "demo", // shows Book a Demo
    scroll_to: "book-a-demo",
  },
  // "/bounce-proof": {
  //   type: "auth",
  //   redirect_url: "https://tryatgff.bounceproof.co/",
  // },
  // "/tamper-proof": {
  //   type: "auth",
  //   redirect_url: "https://tryatgff.tamperproof.co/",
  // },
};
